import Container from "@components/Container/Container";
import {
  BreakingNewsOpinionAndFeatures,
  EPaperLinks,
  FollowBT,
  FollowBTMobile,
  FooterBTLogo,
  FooterDownloadLinks,
  FooterLogos,
  LifestyleLogo,
  LifestyleNavigationItems,
  SectionsNavigationItems,
} from "@components/Footer/FooterComponents/FooterSubComponents";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import cx from "classnames";

export default function FooterTop() {
  return (
    <Container rootClassName="py-4 text-white">
      <Row>
        <Column rootClassName="w-full mx-auto lg:w-8/12">
          <FooterBTLogo />
        </Column>
        <Column rootClassName="w-full lg:w-4/12">
          <FooterDownloadLinks />
        </Column>
      </Row>

      <Row rootClassName="mb-6">
        <Column rootClassName={cx("hidden px-3", "lg:w-8/12 lg:block")}>
          <BreakingNewsOpinionAndFeatures />
        </Column>
        <Column rootClassName="w-full lg:w-4/12">
          <EPaperLinks />
        </Column>
      </Row>

      <Row rootClassName={cx("mt-6 hidden", "lg:flex")}>
        <Column rootClassName="lg:w-6/12">
          <SectionsNavigationItems />
        </Column>
        <Column rootClassName="lg:w-2/12">
          <LifestyleNavigationItems />
        </Column>
        <Column rootClassName="lg:w-3/12">
          <FollowBT />
        </Column>
      </Row>

      <Row rootClassName={cx("flex", "lg:hidden")}>
        <Column rootClassName="w-full">
          <LifestyleLogo />
        </Column>
        <Column rootClassName="w-full mt-6">
          <FollowBTMobile />
        </Column>
      </Row>

      <FooterLogos />
    </Container>
  );
}
